import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { forwardRef, memo, useRef } from "react";
import { mergeRefs } from "react-merge-refs";
import { TextInputBase, textInputBaseClasses, } from "./TextInputBase";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSlotProps } from "../providers/utils/slots";
import { alpha, mergeSx } from "../system";
export const ghostTextFieldClasses = {
    root: "MinervaGhostTextField-root",
    outlined: "MinervaGhostTextField-outlined",
};
export const GhostTextField = memo(forwardRef((props, ref) => {
    const { outlined = false, className, onChange, slotProps, sx, ...rest } = useDefaultProps({
        component: "GhostTextField",
        props,
    });
    const inputRef = useRef(null);
    return (_jsx(TextInputBase, { as: "input", ref: mergeRefs([inputRef, ref]), className: clsx([
            ghostTextFieldClasses.root,
            outlined && ghostTextFieldClasses.outlined,
            className,
        ]), onChange: (e) => {
            onChange?.(e, e.target.value);
        }, size: 10, type: "text", sx: mergeSx({
            [`& .${textInputBaseClasses.focused}`]: {
                boxShadow: "none !important",
            },
            [`& .${textInputBaseClasses["input-root"]}`]: {
                [`&.${textInputBaseClasses.disabled}`]: {
                    backgroundColor: (theme) => theme.palette.background.main,
                },
                [`&.${textInputBaseClasses.focused}`]: {
                    [`& .${textInputBaseClasses.input}`]: {
                        "&::placeholder": {
                            color: (theme) => alpha(theme.palette.background.onMain, 0.25),
                        },
                    },
                },
                [`& .${textInputBaseClasses.input}`]: {
                    "&::placeholder": {
                        color: (theme) => theme.palette.background.onMain,
                    },
                },
            },
            [`&.${ghostTextFieldClasses.root}:not(.${ghostTextFieldClasses.outlined})`]: {
                [`& .${textInputBaseClasses["input-root"]}`]: {
                    paddingX: 1,
                    border: "none",
                    [`&.${textInputBaseClasses.focused}`]: {
                        border: "1px dashed",
                        borderRadius: 0,
                        borderColor: (theme) => theme.palette.outline,
                        [`&.${textInputBaseClasses.error}`]: {
                            borderColor: (theme) => theme.palette.error.main,
                        },
                    },
                },
                [`& .${textInputBaseClasses.input}`]: {
                    minHeight: 7,
                },
            },
            [`&.${ghostTextFieldClasses.outlined}`]: {
                [`& .${textInputBaseClasses.input}`]: {
                    minHeight: 9,
                },
            },
        }, sx), slotProps: mergeSlotProps({
            inputRoot: {
                disableFocusEffect: true,
                disableHoverEffect: true,
            },
        }, slotProps), ...rest }));
}));
//# sourceMappingURL=GhostTextField.js.map